import React, { useState } from 'react';

import { Button } from 'js/components';
import { InlineAlert } from 'js/components/InlineAlert/InlineAlert';
import { faLightbulb } from '@fortawesome/pro-solid-svg-icons';

import { useOnboarding } from './OnboardingContext';

const DISMISSED_KEY = 'waypointr.onboarding.template-hint-dismissed';

function readDismissed() {
  try {
    return window.sessionStorage.getItem(DISMISSED_KEY) === 'true';
  } catch (error) {
    return false;
  }
}

/**
 * A nudge on the template picker while starting an assessment is the user's
 * next checklist step.
 */
export default function TemplateStepHint() {
  const onboarding = useOnboarding();
  const [dismissed, setDismissed] = useState(readDismissed);

  const progress = onboarding?.progress;

  if (dismissed || !progress?.visible || progress.next_step !== 'assessment') {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);

    try {
      window.sessionStorage.setItem(DISMISSED_KEY, 'true');
    } catch (error) {
      // Without storage the hint simply comes back on the next visit.
    }
  };

  return (
    <InlineAlert
      icon={faLightbulb}
      className="mt-3"
      actions={
        <Button color="link" onClick={handleDismiss}>
          Got it
        </Button>
      }
    >
      <strong>Getting started:</strong> pick a template for your first
      assessment. The recommended one is a good place to begin. You'll see all
      of its questions next and can turn off any you don't need before
      launching.
    </InlineAlert>
  );
}
